import { useSignUpMode } from "@/lib/use-public-sign-up";

import SignUpAccountPage from "./account";
import WaitlistPage from "./waitlist";

const SignUpEntry = () => {
  const mode = useSignUpMode();
  if (mode === "waitlist") {
    return <WaitlistPage />;
  }
  return <SignUpAccountPage />;
};

export default SignUpEntry;
